// Note: types exported from `index.d.ts`.
export { math } from './lib/syntax.js';
export { mathHtml } from './lib/html.js';